import type { ReactNode } from 'react'
import { useParams, useSearchParams } from 'react-router'

import EventComponentWrapper from '@/components/EventComponentWrapper'
import EventSettings from '@/components/EventSettings'
import EventStore from '@/components/EventStore/EventStore'
import Player from '@/components/Player/Player'
import { TitleSetter } from '@/components/Title'
import { ROUTE_PARAM } from '@/router/constants'
import { useGetEvent, useGetEventEncoderDetails } from '@/service/eventService'

const eventIdCheck = /^[\w-]+$/

const PlayerConfigWrapper = ({ children }: { children: ReactNode }) => (
  <div style={{ flex: 1, display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
    {children}
  </div>
)

const EventIdNotFound = (
  <EventComponentWrapper>
    <p>No Event ID Found</p>
  </EventComponentWrapper>
)

const InvalidEventId = (eventId: string) => (
  <EventComponentWrapper>
    <p>Invalid Event: {eventId}</p>
  </EventComponentWrapper>
)

export const EventView = () => {
  const [searchParams] = useSearchParams()
  const eventId = useParams()[ROUTE_PARAM.EVENT_ID]
  const { data: event } = useGetEvent(eventId)
  const { data: encoderDetails } = useGetEventEncoderDetails(eventId)

  if (!eventId) return EventIdNotFound

  if (!eventId.match(eventIdCheck)) return InvalidEventId(eventId)

  if (!event) {
    return EventIdNotFound
  }

  const selectedSettingsTab =
    searchParams.get('settings-tab') === 'actions' ? 'actions' : 'settings'

  return (
    <>
      <TitleSetter title="Event Page" />
      <div style={{ display: 'flex', flexDirection: 'column', background: '#EBEAE9' }}>
        <EventStore event={event} />
        <PlayerConfigWrapper>
          <Player
            eventId={eventId}
            streamingConfigId={event.streamingConfig?.id}
            posterUrl={
              event.posterLocation ||
              event.tournament.posterLocation ||
              event.tournament.property.logoUrl
            }
          />
          <EventSettings
            selectedTab={selectedSettingsTab}
            event={event}
            encoderDetails={encoderDetails}
          />
        </PlayerConfigWrapper>
        <pre style={{ whiteSpace: 'pre-wrap', padding: '0 20px' }}>
          {JSON.stringify(event, null, 4)}
        </pre>
      </div>
    </>
  )
}
